import type { ICustomControlDiagnosticReportReadProps } from '../interfaces/customControlDiagnosticReportReadProps';
import { OrthOV1DiagnosticReportBevindingenRead } from './OrthOV1DiagnosticReportBevindingenRead';
import { OrthOV1DiagnosticReportConclusieRead } from './OrthOV1DiagnosticReportConclusieRead';

export function OrthOV1DiagnosticReportRead(props: ICustomControlDiagnosticReportReadProps) {
    return (
        <>
            <OrthOV1DiagnosticReportBevindingenRead {...props} />
            <OrthOV1DiagnosticReportConclusieRead {...props} />
        </>
    );
}
